export const TaskTypeEnum = {
  UpdatedChildConsent: "UPDATED_CHILD_CONSENT",
  UpdatedConsentRequired: "UPDATED_CONSENT_REQUIRED",
  UpdatedPolicies: "UPDATED_POLICIES",
} as const;
